/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var parser = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,5],$V1=[1,4],$V2=[1,3],$V3=[1,6],$V4=[1,8,9,10,11,12,28,35,36,38,40,42,47,63,87,88,89,90,91,92,105,108,109,112,114,117,118,119,124,125,126,127,128],$V5=[2,2],$V6=[1,15],$V7=[1,16],$V8=[1,17],$V9=[1,18],$Va=[1,19],$Vb=[1,26],$Vc=[1,27],$Vd=[1,28],$Ve=[1,30],$Vf=[1,31],$Vg=[1,32],$Vh=[1,55],$Vi=[1,54],$Vj=[1,34],$Vk=[1,35],$Vl=[1,36],$Vm=[1,37],$Vn=[1,38],$Vo=[1,50],$Vp=[1,52],$Vq=[1,48],$Vr=[1,53],$Vs=[1,49],$Vt=[1,56],$Vu=[1,51],$Vv=[1,57],$Vw=[1,58],$Vx=[1,39],$Vy=[1,40],$Vz=[1,41],$VA=[1,42],$VB=[1,43],$VC=[1,64],$VD=[1,8,9,10,11,12,28,33,35,36,38,40,42,47,63,87,88,89,90,91,92,105,108,109,112,114,117,118,119,124,125,126,127,128],$VE=[1,70],$VF=[1,68],$VG=[1,67],$VH=[1,69],$VI=[8,9,10,12,78,80,81],$VJ=[1,88],$VK=[1,101],$VL=[1,106],$VM=[1,105],$VN=[1,102],$VO=[1,98],$VP=[1,104],$VQ=[1,100],$VR=[1,107],$VS=[1,103],$VT=[1,108],$VU=[1,99],$VV=[8,9,10,11,12,43,78,80,81],$VW=[8,9,10,11,12,43,49,78,80,81],$VX=[8,9,10,11,12,30,43,47,49,51,53,55,57,59,61,63,66,68,70,71,73,78,80,81,92,105,108,109,112,114,117,118,119],$VY=[8,9,10,12,47,63,78,80,81,92,105,108,109,112,114,117,118,119],$VZ=[47,63,92,105,108,109,112,114,117,118,119],$V_=[1,131],$V$=[1,132],$V01=[1,134],$V11=[1,133],$V21=[47,63,65,77,92,105,108,109,112,114,117,118,119],$V31=[1,143],$V41=[1,157],$V51=[1,158],$V61=[1,159],$V71=[1,162],$V81=[1,161],$V91=[1,160],$Va1=[1,145],$Vb1=[1,147],$Vc1=[1,151],$Vd1=[1,139],$Ve1=[1,140],$Vf1=[1,152],$Vg1=[1,153],$Vh1=[1,154],$Vi1=[1,155],$Vj1=[1,156],$Vk1=[1,163],$Vl1=[1,164],$Vm1=[1,141],$Vn1=[1,142],$Vo1=[1,149],$Vp1=[1,144],$Vq1=[1,148],$Vr1=[1,146],$Vs1=[8,9,10,11,12,28,33,35,36,38,40,42,47,63,87,88,89,90,91,92,105,108,109,112,114,117,118,119,124,125,126,127,128],$Vt1=[1,168],$Vu1=[1,170],$Vv1=[8,9,10,12],$Vw1=[8,9,10,11,12,15,47,63,92,108,109,112,114,117,118,119],$Vx1=[1,190],$Vy1=[1,186],$Vz1=[1,187],$VA1=[1,191],$VB1=[1,188],$VC1=[1,189],$VD1=[80,119,122],$VE1=[8,9,10,11,12,13,15,28,30,33,35,36,43,47,63,78,87,88,89,90,91,92,93,108,112,114,117,118,119],$VF1=[11,109],$VG1=[32,52,54,56,58,60,65,67,69,70,72,74,119,120,121],$VH1=[1,269],$VI1=[1,267],$VJ1=[1,271],$VK1=[1,265],$VL1=[1,266],$VM1=[1,268],$VN1=[1,270],$VO1=[1,272],$VP1=[1,292],$VQ1=[8,9,10,12,109],$VR1=[8,9,10,11,12,63,87,108,109,112,113,114,115];
var parser = {trace: function trace () { },
yy: {},
symbols_: {"error":2,"start":3,"graphConfig":4,"document":5,"line":6,"statement":7,"COMMENT":8,"SEMI":9,"NEWLINE":10,"SPACE":11,"EOF":12,"GRAPH":13,"NODIR":14,"DIR":15,"FirstStmtSeparator":16,"ending":17,"endToken":18,"spaceList":19,"spaceListNewline":20,"vertexStatement":21,"separator":22,"styleStatement":23,"linkStyleStatement":24,"classDefStatement":25,"classStatement":26,"clickStatement":27,"flow":28,"textNoTags":29,"SQS":30,"text":31,"SQE":32,"end":33,"shapeData":34,"global":35,"connector":36,"direction":37,"acc_title":38,"acc_title_value":39,"acc_descr":40,"acc_descr_value":41,"acc_descr_multiline_value":42,"SHAPE_DATA":43,"link":44,"node":45,"styledVertex":46,"AMP":47,"vertex":48,"STYLE_SEPARATOR":49,"idString":50,"DOUBLECIRCLESTART":51,"DOUBLECIRCLEEND":52,"PS":53,"PE":54,"(-":55,"-)":56,"STADIUMSTART":57,"STADIUMEND":58,"SUBROUTINESTART":59,"SUBROUTINEEND":60,"VERTEX_WITH_PROPS_START":61,"NODE_STRING[field]":62,"COLON":63,"NODE_STRING[value]":64,"PIPE":65,"CYLINDERSTART":66,"CYLINDEREND":67,"DIAMOND_START":68,"DIAMOND_STOP":69,"TAGEND":70,"TRAPSTART":71,"TRAPEND":72,"INVTRAPSTART":73,"INVTRAPEND":74,"linkStatement":75,"arrowText":76,"TESTSTR":77,"START_LINK":78,"edgeText":79,"LINK":80,"LINK_ID":81,"edgeTextToken":82,"STR":83,"MD_STR":84,"textToken":85,"keywords":86,"STYLE":87,"LINKSTYLE":88,"CLASSDEF":89,"CLASS":90,"CLICK":91,"DOWN":92,"UP":93,"textNoTagsToken":94,"stylesOpt":95,"idString[vertex]":96,"idString[class]":97,"CALLBACKNAME":98,"CALLBACKARGS":99,"HREF":100,"LINK_TARGET":101,"STR[link]":102,"STR[tooltip]":103,"alphaNum":104,"DEFAULT":105,"numList":106,"INTERPOLATE":107,"NUM":108,"COMMA":109,"style":110,"styleComponent":111,"NODE_STRING":112,"UNIT":113,"BRKT":114,"PCT":115,"idStringToken":116,"MINUS":117,"MULT":118,"UNICODE_TEXT":119,"TEXT":120,"TAGSTART":121,"EDGE_TEXT":122,"alphaNumToken":123,"direction_tb":124,"direction_bt":125,"direction_rl":126,"direction_lr":127,"direction_td":128,"$accept":0,"$end":1},
terminals_: {2:"error",8:"COMMENT",9:"SEMI",10:"NEWLINE",11:"SPACE",12:"EOF",13:"GRAPH",14:"NODIR",15:"DIR",28:"flow",30:"SQS",32:"SQE",33:"end",35:"global",36:"connector",38:"acc_title",39:"acc_title_value",40:"acc_descr",41:"acc_descr_value",42:"acc_descr_multiline_value",43:"SHAPE_DATA",47:"AMP",49:"STYLE_SEPARATOR",51:"DOUBLECIRCLESTART",52:"DOUBLECIRCLEEND",53:"PS",54:"PE",55:"(-",56:"-)",57:"STADIUMSTART",58:"STADIUMEND",59:"SUBROUTINESTART",60:"SUBROUTINEEND",61:"VERTEX_WITH_PROPS_START",62:"NODE_STRING[field]",63:"COLON",64:"NODE_STRING[value]",65:"PIPE",66:"CYLINDERSTART",67:"CYLINDEREND",68:"DIAMOND_START",69:"DIAMOND_STOP",70:"TAGEND",71:"TRAPSTART",72:"TRAPEND",73:"INVTRAPSTART",74:"INVTRAPEND",77:"TESTSTR",78:"START_LINK",80:"LINK",81:"LINK_ID",83:"STR",84:"MD_STR",87:"STYLE",88:"LINKSTYLE",89:"CLASSDEF",90:"CLASS",91:"CLICK",92:"DOWN",93:"UP",96:"idString[vertex]",97:"idString[class]",98:"CALLBACKNAME",99:"CALLBACKARGS",100:"HREF",101:"LINK_TARGET",102:"STR[link]",103:"STR[tooltip]",105:"DEFAULT",107:"INTERPOLATE",108:"NUM",109:"COMMA",112:"NODE_STRING",113:"UNIT",114:"BRKT",115:"PCT",117:"MINUS",118:"MULT",119:"UNICODE_TEXT",120:"TEXT",121:"TAGSTART",122:"EDGE_TEXT",124:"direction_tb",125:"direction_bt",126:"direction_rl",127:"direction_lr",128:"direction_td"},
productions_: [0,[3,2],[5,0],[5,2],[6,1],[6,1],[6,1],[6,1],[6,1],[6,1],[4,2],[4,2],[4,2],[4,2],[4,3],[17,2],[17,1],[18,1],[18,1],[18,1],[16,1],[16,1],[16,2],[16,1],[20,2],[20,2],[20,2],[20,1],[20,1],[20,1],[19,2],[19,1],[7,2],[7,2],[7,2],[7,2],[7,2],[7,2],[7,9],[7,10],[7,6],[7,7],[7,4],[7,4],[7,7],[7,8],[7,4],[7,5],[7,1],[7,2],[7,2],[7,1],[22,1],[22,1],[22,1],[22,1],[34,2],[34,1],[21,4],[21,3],[21,4],[21,2],[21,2],[21,1],[45,1],[45,6],[45,5],[46,1],[46,3],[48,4],[48,4],[48,6],[48,4],[48,4],[48,4],[48,8],[48,4],[48,4],[48,4],[48,6],[48,4],[48,4],[48,4],[48,4],[48,4],[48,1],[44,2],[44,3],[44,3],[44,1],[44,3],[44,4],[79,1],[79,2],[79,1],[79,1],[75,1],[75,2],[76,3],[31,1],[31,2],[31,1],[31,1],[86,1],[86,1],[86,1],[86,1],[86,1],[86,1],[86,1],[86,1],[86,1],[86,1],[86,1],[86,1],[86,1],[29,1],[29,2],[29,1],[29,1],[25,5],[26,5],[27,2],[27,4],[27,3],[27,5],[27,3],[27,5],[27,5],[27,7],[27,2],[27,4],[27,2],[27,4],[27,4],[27,6],[23,5],[24,5],[24,5],[24,9],[24,9],[24,7],[24,7],[106,1],[106,3],[95,1],[95,3],[110,1],[110,2],[111,1],[111,1],[111,1],[111,1],[111,1],[111,1],[111,1],[111,1],[116,1],[116,1],[116,1],[116,1],[116,1],[116,1],[116,1],[116,1],[116,1],[116,1],[116,1],[85,1],[85,1],[85,1],[85,1],[94,1],[94,1],[94,1],[94,1],[94,1],[94,1],[94,1],[94,1],[94,1],[94,1],[94,1],[82,1],[82,1],[123,1],[123,1],[123,1],[123,1],[123,1],[123,1],[123,1],[123,1],[123,1],[123,1],[123,1],[50,1],[50,2],[104,1],[104,2],[37,1],[37,1],[37,1],[37,1],[37,1]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 2:
 this.$ = [];
break;
case 3:

	    if(!Array.isArray($$[$0]) || $$[$0].length > 0){
	        $$[$0-1].push($$[$0]);
	    }
	    this.$=$$[$0-1];
break;
case 4: case 198:
this.$=$$[$0];
break;
case 5: case 33: case 34: case 35: case 36: case 37:
this.$=[];
break;
case 13:
 yy.setDirection('TB');this.$ = 'TB';
break;
case 14:
 yy.setDirection($$[$0-1]);this.$ = $$[$0-1];
break;
case 32:
 this.$=$$[$0-1].nodes
break;
case 38:
this.$=yy.addSubGraph($$[$0-6],$$[$0-1],$$[$0-4],'flow');if(yy.addSubgraphMapping){yy.addSubgraphMapping($$[$0-6],$$[$0-4],_$[$0-8],_$[$0]);}
break;
case 39:
this.$=yy.addSubGraph($$[$0-7],$$[$0-1],$$[$0-5],'flow');yy.addVertex(this.$,undefined,undefined,undefined,undefined,undefined,undefined,$$[$0-3],_$[$0-3]);if(yy.addSubgraphMapping){yy.addSubgraphMapping($$[$0-7],$$[$0-5],_$[$0-9],_$[$0]);}
break;
case 40:
this.$=yy.addSubGraph($$[$0-3],$$[$0-1],{text:'', type:'text'},'flow');if(yy.addSubgraphMapping){yy.addSubgraphMapping($$[$0-3],{text:'', type:'text'},_$[$0-5],_$[$0]);}
break;
case 41:
this.$=yy.addSubGraph($$[$0-4],$$[$0-1],{text:'', type:'text'},'flow');yy.addVertex(this.$,undefined,undefined,undefined,undefined,undefined,undefined,$$[$0-3],_$[$0-3]);if(yy.addSubgraphMapping){yy.addSubgraphMapping($$[$0-4],{text:'', type:'text'},_$[$0-6],_$[$0]);}
break;
case 42:
this.$=yy.addSubGraph(undefined,$$[$0-1],undefined,'flow');if(yy.addSubgraphMapping){yy.addSubgraphMapping(undefined,undefined,_$[$0-3],_$[$0]);}
break;
case 43:
yy.addGlobal($$[$0-1]);this.$=[];
break;
case 44:
this.$=yy.addConnector($$[$0-4],$$[$0-2]);if(yy.addConnectorMapping){yy.addConnectorMapping($$[$0-4],$$[$0-2],_$[$0-6],_$[$0]);}
break;
case 45:
this.$=yy.addConnector($$[$0-5],$$[$0-3]);yy.addVertex(this.$,undefined,undefined,undefined,undefined,undefined,undefined,$$[$0-1],_$[$0-1]);if(yy.addConnectorMapping){yy.addConnectorMapping($$[$0-5],$$[$0-3],_$[$0-7],_$[$0]);}
break;
case 46:
this.$=yy.addConnector($$[$0-1],{text:'', type:'text'});if(yy.addConnectorMapping){yy.addConnectorMapping($$[$0-1],{text:'', type:'text'},_$[$0-3],_$[$0]);}
break;
case 47:
this.$=yy.addConnector($$[$0-2],{text:'', type:'text'});yy.addVertex(this.$,undefined,undefined,undefined,undefined,undefined,undefined,$$[$0-1],_$[$0-1]);if(yy.addConnectorMapping){yy.addConnectorMapping($$[$0-2],{text:'', type:'text'},_$[$0-4],_$[$0]);}
break;
case 49:
 this.$=$$[$0].trim();yy.setAccTitle(this.$); 
break;
case 50: case 51:
 this.$=$$[$0].trim();yy.setAccDescription(this.$); 
break;
case 56:
 this.$ = $$[$0-1] + $$[$0]; 
break;
case 57:
 this.$ = $$[$0]; 
break;
case 58:
 /* console.warn('vs shapeData',$$[$0-3].stmt,$$[$0-1], $$[$0]);*/ yy.addVertex($$[$0-1][$$[$0-1].length-1],undefined,undefined,undefined, undefined,undefined, undefined,$$[$0],_$[$0]); if(yy.extendVertexMapping){yy.extendVertexMapping($$[$0-1][$$[$0-1].length-1],_$[$0]);} yy.addLink($$[$0-3].stmt,$$[$0-1],$$[$0-2]); if(yy.addEdgeMapping){yy.addEdgeMapping($$[$0-3].stmt,$$[$0-1],$$[$0-2],this._$);} this.$ = { stmt: $$[$0-1], nodes: $$[$0-1].concat($$[$0-3].nodes) } 
break;
case 59:
 /*console.warn('vs',$$[$0-2].stmt,$$[$0]);*/ yy.addLink($$[$0-2].stmt,$$[$0],$$[$0-1]); if(yy.addEdgeMapping){yy.addEdgeMapping($$[$0-2].stmt,$$[$0],$$[$0-1],this._$);} this.$ = { stmt: $$[$0], nodes: $$[$0].concat($$[$0-2].nodes) } 
break;
case 60:
 /* console.warn('vs',$$[$0-3].stmt,$$[$0-1]); */ yy.addLink($$[$0-3].stmt,$$[$0-1],$$[$0-2]); if(yy.addEdgeMapping){yy.addEdgeMapping($$[$0-3].stmt,$$[$0-1],$$[$0-2],this._$);} this.$ = { stmt: $$[$0-1], nodes: $$[$0-1].concat($$[$0-3].nodes) } 
break;
case 61:
 /*console.warn('vertexStatement: node spaceList', $$[$0-1]);*/ this.$ = {stmt: $$[$0-1], nodes:$$[$0-1] }
break;
case 62:

        /*console.warn('vertexStatement: node shapeData', $$[$0-1][0], $$[$0]);*/
        yy.addVertex($$[$0-1][$$[$0-1].length-1],undefined,undefined,undefined, undefined,undefined, undefined,$$[$0],_$[$0]);
        if(yy.extendVertexMapping){yy.extendVertexMapping($$[$0-1][$$[$0-1].length-1],_$[$0]);}
        this.$ = {stmt: $$[$0-1], nodes:$$[$0-1], shapeData: $$[$0]}
    
break;
case 63:
 /* console.warn('vertexStatement: single node', $$[$0]); */ this.$ = {stmt: $$[$0], nodes:$$[$0] }
break;
case 64:
 /*console.warn('nod', $$[$0]);*/ this.$ = [$$[$0]];
break;
case 65:
  yy.addVertex($$[$0-5][$$[$0-5].length-1],undefined,undefined,undefined, undefined,undefined, undefined,$$[$0-4],_$[$0-4]); if(yy.extendVertexMapping){yy.extendVertexMapping($$[$0-5][$$[$0-5].length-1],_$[$0-4]);} this.$ = $$[$0-5].concat($$[$0]); /*console.warn('pip2', $$[$0-5][0], $$[$0], this.$);*/  
break;
case 66:
 this.$ = $$[$0-4].concat($$[$0]); /*console.warn('pip', $$[$0-4][0], $$[$0], this.$);*/  
break;
case 67:
 /* console.warn('nodc', $$[$0]);*/ this.$ = $$[$0];
break;
case 68:
this.$ = $$[$0-2];yy.setClass($$[$0-2],$$[$0])
break;
case 69:
this.$ = $$[$0-3];yy.addVertex($$[$0-3],$$[$0-1],'square');if(yy.addVertexMapping){yy.addVertexMapping($$[$0-3],$$[$0-1],'square',this._$);}
break;
case 70:
this.$ = $$[$0-3];yy.addVertex($$[$0-3],$$[$0-1],'doublecircle');if(yy.addVertexMapping){yy.addVertexMapping($$[$0-3],$$[$0-1],'doublecircle',this._$);}
break;
case 71:
this.$ = $$[$0-5];yy.addVertex($$[$0-5],$$[$0-2],'circle');if(yy.addVertexMapping){yy.addVertexMapping($$[$0-5],$$[$0-2],'circle',this._$);}
break;
case 72:
this.$ = $$[$0-3];yy.addVertex($$[$0-3],$$[$0-1],'ellipse');if(yy.addVertexMapping){yy.addVertexMapping($$[$0-3],$$[$0-1],'ellipse',this._$);}
break;
case 73:
this.$ = $$[$0-3];yy.addVertex($$[$0-3],$$[$0-1],'stadium');if(yy.addVertexMapping){yy.addVertexMapping($$[$0-3],$$[$0-1],'stadium',this._$);}
break;
case 74:
this.$ = $$[$0-3];yy.addVertex($$[$0-3],$$[$0-1],'subroutine');if(yy.addVertexMapping){yy.addVertexMapping($$[$0-3],$$[$0-1],'subroutine',this._$);}
break;
case 75:
this.$ = $$[$0-7];yy.addVertex($$[$0-7],$$[$0-1],'rect',undefined,undefined,undefined, Object.fromEntries([[$$[$0-5], $$[$0-3]]]));if(yy.addVertexMapping){yy.addVertexMapping($$[$0-7],$$[$0-1],'rect',this._$);}
break;
case 76:
this.$ = $$[$0-3];yy.addVertex($$[$0-3],$$[$0-1],'cylinder');if(yy.addVertexMapping){yy.addVertexMapping($$[$0-3],$$[$0-1],'cylinder',this._$);}
break;
case 77:
this.$ = $$[$0-3];yy.addVertex($$[$0-3],$$[$0-1],'round');if(yy.addVertexMapping){yy.addVertexMapping($$[$0-3],$$[$0-1],'round',this._$);}
break;
case 78:
this.$ = $$[$0-3];yy.addVertex($$[$0-3],$$[$0-1],'diamond');if(yy.addVertexMapping){yy.addVertexMapping($$[$0-3],$$[$0-1],'diamond',this._$);}
break;
case 79:
this.$ = $$[$0-5];yy.addVertex($$[$0-5],$$[$0-2],'hexagon');if(yy.addVertexMapping){yy.addVertexMapping($$[$0-5],$$[$0-2],'hexagon',this._$);}
break;
case 80:
this.$ = $$[$0-3];yy.addVertex($$[$0-3],$$[$0-1],'odd');if(yy.addVertexMapping){yy.addVertexMapping($$[$0-3],$$[$0-1],'odd',this._$);}
break;
case 81:
this.$ = $$[$0-3];yy.addVertex($$[$0-3],$$[$0-1],'trapezoid');if(yy.addVertexMapping){yy.addVertexMapping($$[$0-3],$$[$0-1],'trapezoid',this._$);}
break;
case 82:
this.$ = $$[$0-3];yy.addVertex($$[$0-3],$$[$0-1],'inv_trapezoid');if(yy.addVertexMapping){yy.addVertexMapping($$[$0-3],$$[$0-1],'inv_trapezoid',this._$);}
break;
case 83:
this.$ = $$[$0-3];yy.addVertex($$[$0-3],$$[$0-1],'lean_right');if(yy.addVertexMapping){yy.addVertexMapping($$[$0-3],$$[$0-1],'lean_right',this._$);}
break;
case 84:
this.$ = $$[$0-3];yy.addVertex($$[$0-3],$$[$0-1],'lean_left');if(yy.addVertexMapping){yy.addVertexMapping($$[$0-3],$$[$0-1],'lean_left',this._$);}
break;
case 85:
 /*console.warn('h: ', $$[$0]);*/this.$ = $$[$0];yy.addVertex($$[$0]);if(yy.addVertexMapping){yy.addVertexMapping($$[$0],undefined,undefined,this._$);}
break;
case 86:
$$[$0-1].text = $$[$0];this.$ = $$[$0-1];
break;
case 87: case 88:
$$[$0-2].text = $$[$0-1];this.$ = $$[$0-2];
break;
case 89:
this.$ = $$[$0];
break;
case 90:
var inf = yy.destructLink($$[$0], $$[$0-2]); this.$ = {"type":inf.type,"stroke":inf.stroke,"length":inf.length,"edgeSemantic":inf.edgeSemantic,"text":$$[$0-1]};
break;
case 91:
var inf = yy.destructLink($$[$0], $$[$0-2]); this.$ = {"type":inf.type,"stroke":inf.stroke,"length":inf.length,"edgeSemantic":inf.edgeSemantic,"text":$$[$0-1], "id": $$[$0-3]};
break;
case 92:
this.$={text:$$[$0], type:'text'};
break;
case 93:
this.$={text:$$[$0-1].text+''+$$[$0], type:$$[$0-1].type};
break;
case 94:
this.$={text: $$[$0], type: 'string'};
break;
case 95:
this.$={text:$$[$0], type:'markdown'};
break;
case 96:
var inf = yy.destructLink($$[$0]);this.$ = {"type":inf.type,"stroke":inf.stroke,"length":inf.length,"edgeSemantic":inf.edgeSemantic};
break;
case 97:
var inf = yy.destructLink($$[$0]);this.$ = {"type":inf.type,"stroke":inf.stroke,"length":inf.length,"edgeSemantic":inf.edgeSemantic, "id": $$[$0-1]};
break;
case 98:
this.$ = $$[$0-1];
break;
case 99:
 this.$={text:$$[$0], type: 'text'};
break;
case 100:
 this.$={text:$$[$0-1].text+''+$$[$0], type: $$[$0-1].type};
break;
case 101:
 this.$ = {text: $$[$0], type: 'string'};
break;
case 102: case 119:
 this.$={text: $$[$0], type: 'markdown'};
break;
case 116:
this.$={text:$$[$0], type: 'text'};
break;
case 117:
this.$={text:$$[$0-1].text+''+$$[$0], type: $$[$0-1].type};
break;
case 118:
 this.$={text: $$[$0], type: 'text'};
break;
case 120:
this.$ = $$[$0-4];yy.addClass($$[$0-2],$$[$0]);
break;
case 121:
this.$ = $$[$0-4];yy.setClass($$[$0-2], $$[$0]);
break;
case 122: case 130:
this.$ = $$[$0-1];yy.setClickEvent($$[$0-1], $$[$0]);
break;
case 123: case 131:
this.$ = $$[$0-3];yy.setClickEvent($$[$0-3], $$[$0-2]);yy.setTooltip($$[$0-3], $$[$0]);
break;
case 124:
this.$ = $$[$0-2];yy.setClickEvent($$[$0-2], $$[$0-1], $$[$0]);
break;
case 125:
this.$ = $$[$0-4];yy.setClickEvent($$[$0-4], $$[$0-3], $$[$0-2]);yy.setTooltip($$[$0-4], $$[$0]);
break;
case 126:
this.$ = $$[$0-2];yy.setLink($$[$0-2], $$[$0]);
break;
case 127:
this.$ = $$[$0-4];yy.setLink($$[$0-4], $$[$0-2]);yy.setTooltip($$[$0-4], $$[$0]);
break;
case 128:
this.$ = $$[$0-4];yy.setLink($$[$0-4], $$[$0-2], $$[$0]);
break;
case 129:
this.$ = $$[$0-6];yy.setLink($$[$0-6], $$[$0-4], $$[$0]);yy.setTooltip($$[$0-6], $$[$0-2]);
break;
case 132:
this.$ = $$[$0-1];yy.setLink($$[$0-1], $$[$0]);
break;
case 133:
this.$ = $$[$0-3];yy.setLink($$[$0-3], $$[$0-2]);yy.setTooltip($$[$0-3], $$[$0]);
break;
case 134:
this.$ = $$[$0-3];yy.setLink($$[$0-3], $$[$0-2], $$[$0]);
break;
case 135:
this.$ = $$[$0-5];yy.setLink($$[$0-5], $$[$0-4], $$[$0]);yy.setTooltip($$[$0-5], $$[$0-2]);
break;
case 136:
this.$ = $$[$0-4];yy.addVertex($$[$0-2],undefined,undefined,$$[$0]);
break;
case 137:
this.$ = $$[$0-4];yy.updateLink([$$[$0-2]],$$[$0]);
break;
case 138:
this.$ = $$[$0-4];yy.updateLink($$[$0-2],$$[$0]);
break;
case 139:
this.$ = $$[$0-8];yy.updateLinkInterpolate([$$[$0-6]],$$[$0-2]);yy.updateLink([$$[$0-6]],$$[$0]);
break;
case 140:
this.$ = $$[$0-8];yy.updateLinkInterpolate($$[$0-6],$$[$0-2]);yy.updateLink($$[$0-6],$$[$0]);
break;
case 141:
this.$ = $$[$0-6];yy.updateLinkInterpolate([$$[$0-4]],$$[$0]);
break;
case 142:
this.$ = $$[$0-6];yy.updateLinkInterpolate($$[$0-4],$$[$0]);
break;
case 143: case 145:
this.$ = [$$[$0]]
break;
case 144: case 146:
$$[$0-2].push($$[$0]);this.$ = $$[$0-2];
break;
case 148:
this.$ = $$[$0-1] + $$[$0];
break;
case 196:
this.$=$$[$0]
break;
case 197:
this.$=$$[$0-1]+''+$$[$0]
break;
case 199:
this.$=$$[$0-1]+''+$$[$0];
break;
case 200:
 this.$={stmt:'dir', value:'TB'};
break;
case 201:
 this.$={stmt:'dir', value:'BT'};
break;
case 202:
 this.$={stmt:'dir', value:'RL'};
break;
case 203:
 this.$={stmt:'dir', value:'LR'};
break;
case 204:
 this.$={stmt:'dir', value:'TD'};
break;
}
},
table: [{3:1,4:2,8:$V0,10:$V1,11:$V2,13:$V3},{1:[3]},o($V4,$V5,{5:7}),{4:8,8:$V0,10:$V1,11:$V2,13:$V3},{4:9,8:$V0,10:$V1,11:$V2,13:$V3},{4:10,8:$V0,10:$V1,11:$V2,13:$V3},{14:[1,11],15:[1,12]},{1:[2,1],6:13,7:14,8:$V6,9:$V7,10:$V8,11:$V9,12:$Va,21:20,23:21,24:22,25:23,26:24,27:25,28:$Vb,35:$Vc,36:$Vd,37:29,38:$Ve,40:$Vf,42:$Vg,45:33,46:44,47:$Vh,48:45,50:46,63:$Vi,87:$Vj,88:$Vk,89:$Vl,90:$Vm,91:$Vn,92:$Vo,105:$Vp,108:$Vq,109:$Vr,112:$Vs,114:$Vt,116:47,117:$Vu,118:$Vv,119:$Vw,124:$Vx,125:$Vy,126:$Vz,127:$VA,128:$VB},o($V4,[2,10]),o($V4,[2,11]),o($V4,[2,12]),o($V4,[2,13]),{8:[1,63],9:[1,60],10:[1,61],11:$VC,16:59,19:62},o($VD,[2,3]),o($VD,[2,4]),o($VD,[2,5]),o($VD,[2,6]),o($VD,[2,7]),o($VD,[2,8]),o($VD,[2,9]),{8:$VE,9:$VF,10:$VG,12:$VH,22:65,44:66,75:71,78:[1,72],80:[1,74],81:[1,73]},{8:$VE,9:$VF,10:$VG,12:$VH,22:75},{8:$VE,9:$VF,10:$VG,12:$VH,22:76},{8:$VE,9:$VF,10:$VG,12:$VH,22:77},{8:$VE,9:$VF,10:$VG,12:$VH,22:78},{8:$VE,9:$VF,10:$VG,12:$VH,22:79},{8:$VE,9:$VF,10:$VG,11:[1,80],12:$VH,22:81},{8:$VE,9:$VF,10:$VG,12:$VH,22:82},{11:[1,83]},o($VD,[2,48]),{39:[1,84]},{41:[1,85]},o($VD,[2,51]),o($VI,[2,63],{19:86,34:87,11:$VC,43:$VJ}),{11:[1,89]},{11:[1,90]},{11:[1,91]},{11:[1,92]},{15:$VK,47:$VL,63:$VM,83:[1,96],92:$VN,98:[1,93],100:[1,94],104:95,108:$VO,109:$VP,112:$VQ,114:$VR,117:$VS,118:$VT,119:$VU,123:97},o($VD,[2,200]),o($VD,[2,201]),o($VD,[2,202]),o($VD,[2,203]),o($VD,[2,204]),o($VV,[2,64]),o($VV,[2,67],{49:[1,109]}),o($VW,[2,85],{116:122,30:[1,110],47:$Vh,51:[1,111],53:[1,112],55:[1,113],57:[1,114],59:[1,115],61:[1,116],63:$Vi,66:[1,117],68:[1,118],70:[1,119],71:[1,120],73:[1,121],92:$Vo,105:$Vp,108:$Vq,109:$Vr,112:$Vs,114:$Vt,117:$Vu,118:$Vv,119:$Vw}),o($VX,[2,196]),o($VX,[2,157]),o($VX,[2,158]),o($VX,[2,159]),o($VX,[2,160]),o($VX,[2,161]),o($VX,[2,162]),o($VX,[2,163]),o($VX,[2,164]),o($VX,[2,165]),o($VX,[2,166]),o($VX,[2,167]),o($V4,[2,14]),o($V4,[2,20]),o($V4,[2,21]),{10:[1,123]},o($V4,[2,23]),o($VY,[2,31],{19:124,11:$VC}),o($VD,[2,32]),{45:125,46:44,47:$Vh,48:45,50:46,63:$Vi,92:$Vo,105:$Vp,108:$Vq,109:$Vr,112:$Vs,114:$Vt,116:47,117:$Vu,118:$Vv,119:$Vw},o($VD,[2,52]),o($VD,[2,53]),o($VD,[2,54]),o($VD,[2,55]),o($VZ,[2,89],{76:126,65:[1,128],77:[1,127]}),{79:129,82:130,83:$V_,84:$V$,119:$V01,122:$V11},{78:[1,135],80:[1,136]},o($V21,[2,96]),o($VD,[2,33]),o($VD,[2,34]),o($VD,[2,35]),o($VD,[2,36]),o($VD,[2,37]),{11:$V31,13:$V41,15:$V51,28:$V61,29:137,33:$V71,35:$V81,36:$V91,47:$Va1,63:$Vb1,78:$Vc1,83:$Vd1,84:$Ve1,86:150,87:$Vf1,88:$Vg1,89:$Vh1,90:$Vi1,91:$Vj1,92:$Vk1,93:$Vl1,94:138,108:$Vm1,112:$Vn1,114:$Vo1,117:$Vp1,118:$Vq1,119:$Vr1},o($Vs1,$V5,{5:165}),o($Vs1,$V5,{5:166}),{11:$V31,13:$V41,15:$V51,28:$V61,29:167,33:$V71,35:$V81,36:$V91,47:$Va1,63:$Vb1,78:$Vc1,83:$Vd1,84:$Ve1,86:150,87:$Vf1,88:$Vg1,89:$Vh1,90:$Vi1,91:$Vj1,92:$Vk1,93:$Vl1,94:138,108:$Vm1,112:$Vn1,114:$Vo1,117:$Vp1,118:$Vq1,119:$Vr1},o($VD,[2,49]),o($VD,[2,50]),o($VI,[2,61],{47:$Vt1}),o($VI,[2,62],{19:169,11:$VC,43:$Vu1}),o($VV,[2,57]),{47:$Vh,50:171,63:$Vi,92:$Vo,105:$Vp,108:$Vq,109:$Vr,112:$Vs,114:$Vt,116:47,117:$Vu,118:$Vv,119:$Vw},{105:[1,172],106:173,108:[1,174]},{47:$Vh,50:175,63:$Vi,92:$Vo,105:$Vp,108:$Vq,109:$Vr,112:$Vs,114:$Vt,116:47,117:$Vu,118:$Vv,119:$Vw},{47:$Vh,50:176,63:$Vi,92:$Vo,105:$Vp,108:$Vq,109:$Vr,112:$Vs,114:$Vt,116:47,117:$Vu,118:$Vv,119:$Vw},o($Vv1,[2,122],{11:[1,177],99:[1,178]}),{83:[1,179]},o($Vv1,[2,130],{123:181,11:[1,180],15:$VK,47:$VL,63:$VM,92:$VN,108:$VO,109:$VP,112:$VQ,114:$VR,117:$VS,118:$VT,119:$VU}),o($Vv1,[2,132],{11:[1,182]}),o($Vw1,[2,198]),o($Vw1,[2,185]),o($Vw1,[2,186]),o($Vw1,[2,187]),o($Vw1,[2,188]),o($Vw1,[2,189]),o($Vw1,[2,190]),o($Vw1,[2,191]),o($Vw1,[2,192]),o($Vw1,[2,193]),o($Vw1,[2,194]),o($Vw1,[2,195]),{47:$Vh,50:183,63:$Vi,92:$Vo,105:$Vp,108:$Vq,109:$Vr,112:$Vs,114:$Vt,116:47,117:$Vu,118:$Vv,119:$Vw},{31:184,70:$Vx1,83:$Vy1,84:$Vz1,85:185,119:$VA1,120:$VB1,121:$VC1},{31:192,70:$Vx1,83:$Vy1,84:$Vz1,85:185,119:$VA1,120:$VB1,121:$VC1},{31:194,53:[1,193],70:$Vx1,83:$Vy1,84:$Vz1,85:185,119:$VA1,120:$VB1,121:$VC1},{31:195,70:$Vx1,83:$Vy1,84:$Vz1,85:185,119:$VA1,120:$VB1,121:$VC1},{31:196,70:$Vx1,83:$Vy1,84:$Vz1,85:185,119:$VA1,120:$VB1,121:$VC1},{31:197,70:$Vx1,83:$Vy1,84:$Vz1,85:185,119:$VA1,120:$VB1,121:$VC1},{112:[1,198]},{31:199,70:$Vx1,83:$Vy1,84:$Vz1,85:185,119:$VA1,120:$VB1,121:$VC1},{31:200,68:[1,201],70:$Vx1,83:$Vy1,84:$Vz1,85:185,119:$VA1,120:$VB1,121:$VC1},{31:202,70:$Vx1,83:$Vy1,84:$Vz1,85:185,119:$VA1,120:$VB1,121:$VC1},{31:203,70:$Vx1,83:$Vy1,84:$Vz1,85:185,119:$VA1,120:$VB1,121:$VC1},{31:204,70:$Vx1,83:$Vy1,84:$Vz1,85:185,119:$VA1,120:$VB1,121:$VC1},o($VX,[2,197]),o($V4,[2,22]),o($VY,[2,30]),o($VI,[2,59],{34:205,19:206,11:$VC,43:$VJ}),o($VZ,[2,86],{11:[1,207]}),{11:[1,208]},{31:209,70:$Vx1,83:$Vy1,84:$Vz1,85:185,119:$VA1,120:$VB1,121:$VC1},{80:[1,210],82:211,119:$V01,122:$V11},o($VD1,[2,92]),o($VD1,[2,94]),o($VD1,[2,95]),o($VD1,[2,183]),o($VD1,[2,184]),{79:212,82:130,83:$V_,84:$V$,119:$V01,122:$V11},o($V21,[2,97]),{8:$VE,9:$VF,10:$VG,11:$V31,12:$VH,13:$V41,15:$V51,22:214,28:$V61,30:[1,213],33:$V71,34:215,35:$V81,36:$V91,43:$VJ,47:$Va1,63:$Vb1,78:$Vc1,86:150,87:$Vf1,88:$Vg1,89:$Vh1,90:$Vi1,91:$Vj1,92:$Vk1,93:$Vl1,94:216,108:$Vm1,112:$Vn1,114:$Vo1,117:$Vp1,118:$Vq1,119:$Vr1},o($VE1,[2,116]),o($VE1,[2,118]),o($VE1,[2,119]),o($VE1,[2,172]),o($VE1,[2,173]),o($VE1,[2,174]),o($VE1,[2,175]),o($VE1,[2,176]),o($VE1,[2,177]),o($VE1,[2,178]),o($VE1,[2,179]),o($VE1,[2,180]),o($VE1,[2,181]),o($VE1,[2,182]),o($VE1,[2,103]),o($VE1,[2,104]),o($VE1,[2,105]),o($VE1,[2,106]),o($VE1,[2,107]),o($VE1,[2,108]),o($VE1,[2,109]),o($VE1,[2,110]),o($VE1,[2,111]),o($VE1,[2,112]),o($VE1,[2,113]),o($VE1,[2,114]),o($VE1,[2,115]),{6:13,7:14,8:$V6,9:$V7,10:$V8,11:$V9,12:$Va,21:20,23:21,24:22,25:23,26:24,27:25,28:$Vb,33:[1,217],35:$Vc,36:$Vd,37:29,38:$Ve,40:$Vf,42:$Vg,45:33,46:44,47:$Vh,48:45,50:46,63:$Vi,87:$Vj,88:$Vk,89:$Vl,90:$Vm,91:$Vn,92:$Vo,105:$Vp,108:$Vq,109:$Vr,112:$Vs,114:$Vt,116:47,117:$Vu,118:$Vv,119:$Vw,124:$Vx,125:$Vy,126:$Vz,127:$VA,128:$VB},{6:13,7:14,8:$V6,9:$V7,10:$V8,11:$V9,12:$Va,21:20,23:21,24:22,25:23,26:24,27:25,28:$Vb,33:[1,218],35:$Vc,36:$Vd,37:29,38:$Ve,40:$Vf,42:$Vg,45:33,46:44,47:$Vh,48:45,50:46,63:$Vi,87:$Vj,88:$Vk,89:$Vl,90:$Vm,91:$Vn,92:$Vo,105:$Vp,108:$Vq,109:$Vr,112:$Vs,114:$Vt,116:47,117:$Vu,118:$Vv,119:$Vw,124:$Vx,125:$Vy,126:$Vz,127:$VA,128:$VB},{8:$VE,9:$VF,10:$VG,11:$V31,12:$VH,13:$V41,15:$V51,22:220,28:$V61,30:[1,219],33:$V71,34:221,35:$V81,36:$V91,43:$VJ,47:$Va1,63:$Vb1,78:$Vc1,86:150,87:$Vf1,88:$Vg1,89:$Vh1,90:$Vi1,91:$Vj1,92:$Vk1,93:$Vl1,94:216,108:$Vm1,112:$Vn1,114:$Vo1,117:$Vp1,118:$Vq1,119:$Vr1},{11:$VC,19:222},{47:[1,223]},o($VV,[2,56]),{11:[1,224],47:$Vh,63:$Vi,92:$Vo,105:$Vp,108:$Vq,109:$Vr,112:$Vs,114:$Vt,116:122,117:$Vu,118:$Vv,119:$Vw},{11:[1,225]},{11:[1,226],109:[1,227]},o($VF1,[2,143]),{11:[1,228],47:$Vh,63:$Vi,92:$Vo,105:$Vp,108:$Vq,109:$Vr,112:$Vs,114:$Vt,116:122,117:$Vu,118:$Vv,119:$Vw},{11:[1,229],47:$Vh,63:$Vi,92:$Vo,105:$Vp,108:$Vq,109:$Vr,112:$Vs,114:$Vt,116:122,117:$Vu,118:$Vv,119:$Vw},{83:[1,230]},o($Vv1,[2,124],{11:[1,231]}),o($Vv1,[2,126],{11:[1,232]}),{83:[1,233]},o($Vw1,[2,199]),{83:[1,234],101:[1,235]},o($VV,[2,68],{116:122,47:$Vh,63:$Vi,92:$Vo,105:$Vp,108:$Vq,109:$Vr,112:$Vs,114:$Vt,117:$Vu,118:$Vv,119:$Vw}),{32:[1,236],70:$Vx1,85:237,119:$VA1,120:$VB1,121:$VC1},o($VG1,[2,99]),o($VG1,[2,101]),o($VG1,[2,102]),o($VG1,[2,168]),o($VG1,[2,169]),o($VG1,[2,170]),o($VG1,[2,171]),{52:[1,238],70:$Vx1,85:237,119:$VA1,120:$VB1,121:$VC1},{31:239,70:$Vx1,83:$Vy1,84:$Vz1,85:185,119:$VA1,120:$VB1,121:$VC1},{54:[1,240],70:$Vx1,85:237,119:$VA1,120:$VB1,121:$VC1},{56:[1,241],70:$Vx1,85:237,119:$VA1,120:$VB1,121:$VC1},{58:[1,242],70:$Vx1,85:237,119:$VA1,120:$VB1,121:$VC1},{60:[1,243],70:$Vx1,85:237,119:$VA1,120:$VB1,121:$VC1},{63:[1,244]},{67:[1,245],70:$Vx1,85:237,119:$VA1,120:$VB1,121:$VC1},{69:[1,246],70:$Vx1,85:237,119:$VA1,120:$VB1,121:$VC1},{31:247,70:$Vx1,83:$Vy1,84:$Vz1,85:185,119:$VA1,120:$VB1,121:$VC1},{32:[1,248],70:$Vx1,85:237,119:$VA1,120:$VB1,121:$VC1},{70:$Vx1,72:[1,249],74:[1,250],85:237,119:$VA1,120:$VB1,121:$VC1},{70:$Vx1,72:[1,252],74:[1,251],85:237,119:$VA1,120:$VB1,121:$VC1},o($VI,[2,58],{19:169,11:$VC,43:$Vu1}),o($VI,[2,60],{47:$Vt1}),o($VZ,[2,88]),o($VZ,[2,87]),{65:[1,253],70:$Vx1,85:237,119:$VA1,120:$VB1,121:$VC1},o($VZ,[2,90]),o($VD1,[2,93]),{80:[1,254],82:211,119:$V01,122:$V11},{31:255,70:$Vx1,83:$Vy1,84:$Vz1,85:185,119:$VA1,120:$VB1,121:$VC1},o($Vs1,$V5,{5:256}),{8:$VE,9:$VF,10:$VG,12:$VH,22:257,43:$Vu1},o($VE1,[2,117]),o($VD,[2,42]),o($VD,[2,43]),{31:258,70:$Vx1,83:$Vy1,84:$Vz1,85:185,119:$VA1,120:$VB1,121:$VC1},o($VD,[2,46]),{8:$VE,9:$VF,10:$VG,12:$VH,22:259,43:$Vu1},{46:260,47:$Vh,48:45,50:46,63:$Vi,92:$Vo,105:$Vp,108:$Vq,109:$Vr,112:$Vs,114:$Vt,116:47,117:$Vu,118:$Vv,119:$Vw},{11:$VC,19:261},{11:$VH1,63:$VI1,87:$VJ1,95:262,108:$VK1,110:263,111:264,112:$VL1,113:$VM1,114:$VN1,115:$VO1},{11:$VH1,63:$VI1,87:$VJ1,95:273,107:[1,274],108:$VK1,110:263,111:264,112:$VL1,113:$VM1,114:$VN1,115:$VO1},{11:$VH1,63:$VI1,87:$VJ1,95:275,107:[1,276],108:$VK1,110:263,111:264,112:$VL1,113:$VM1,114:$VN1,115:$VO1},{108:[1,277]},{11:$VH1,63:$VI1,87:$VJ1,95:278,108:$VK1,110:263,111:264,112:$VL1,113:$VM1,114:$VN1,115:$VO1},{47:$Vh,50:279,63:$Vi,92:$Vo,105:$Vp,108:$Vq,109:$Vr,112:$Vs,114:$Vt,116:47,117:$Vu,118:$Vv,119:$Vw},o($Vv1,[2,123]),{83:[1,280]},{83:[1,281],101:[1,282]},o($Vv1,[2,131]),o($Vv1,[2,133],{11:[1,283]}),o($Vv1,[2,134]),o($VW,[2,69]),o($VG1,[2,100]),o($VW,[2,70]),{54:[1,284],70:$Vx1,85:237,119:$VA1,120:$VB1,121:$VC1},o($VW,[2,77]),o($VW,[2,72]),o($VW,[2,73]),o($VW,[2,74]),{112:[1,285]},o($VW,[2,76]),o($VW,[2,78]),{69:[1,286],70:$Vx1,85:237,119:$VA1,120:$VB1,121:$VC1},o($VW,[2,80]),o($VW,[2,81]),o($VW,[2,83]),o($VW,[2,82]),o($VW,[2,84]),o([11,47,63,92,105,108,109,112,114,117,118,119],[2,98]),o($VZ,[2,91]),{32:[1,287],70:$Vx1,85:237,119:$VA1,120:$VB1,121:$VC1},{6:13,7:14,8:$V6,9:$V7,10:$V8,11:$V9,12:$Va,21:20,23:21,24:22,25:23,26:24,27:25,28:$Vb,33:[1,288],35:$Vc,36:$Vd,37:29,38:$Ve,40:$Vf,42:$Vg,45:33,46:44,47:$Vh,48:45,50:46,63:$Vi,87:$Vj,88:$Vk,89:$Vl,90:$Vm,91:$Vn,92:$Vo,105:$Vp,108:$Vq,109:$Vr,112:$Vs,114:$Vt,116:47,117:$Vu,118:$Vv,119:$Vw,124:$Vx,125:$Vy,126:$Vz,127:$VA,128:$VB},o($Vs1,$V5,{5:289}),{32:[1,290],70:$Vx1,85:237,119:$VA1,120:$VB1,121:$VC1},o($VD,[2,47]),o($VV,[2,66]),{46:291,47:$Vh,48:45,50:46,63:$Vi,92:$Vo,105:$Vp,108:$Vq,109:$Vr,112:$Vs,114:$Vt,116:47,117:$Vu,118:$Vv,119:$Vw},o($Vv1,[2,136],{109:$VP1}),o($VQ1,[2,145],{111:293,11:$VH1,63:$VI1,87:$VJ1,108:$VK1,112:$VL1,113:$VM1,114:$VN1,115:$VO1}),o($VR1,[2,147]),o($VR1,[2,149]),o($VR1,[2,150]),o($VR1,[2,151]),o($VR1,[2,152]),o($VR1,[2,153]),o($VR1,[2,154]),o($VR1,[2,155]),o($VR1,[2,156]),o($Vv1,[2,137],{109:$VP1}),{11:[1,294]},o($Vv1,[2,138],{109:$VP1}),{11:[1,295]},o($VF1,[2,144]),o($Vv1,[2,120],{109:$VP1}),o($Vv1,[2,121],{116:122,47:$Vh,63:$Vi,92:$Vo,105:$Vp,108:$Vq,109:$Vr,112:$Vs,114:$Vt,117:$Vu,118:$Vv,119:$Vw}),o($Vv1,[2,125]),o($Vv1,[2,127],{11:[1,296]}),o($Vv1,[2,128]),{101:[1,297]},{54:[1,298]},{65:[1,299]},{69:[1,300]},{8:$VE,9:$VF,10:$VG,12:$VH,22:301,34:302,43:$VJ},o($VD,[2,40]),{6:13,7:14,8:$V6,9:$V7,10:$V8,11:$V9,12:$Va,21:20,23:21,24:22,25:23,26:24,27:25,28:$Vb,33:[1,303],35:$Vc,36:$Vd,37:29,38:$Ve,40:$Vf,42:$Vg,45:33,46:44,47:$Vh,48:45,50:46,63:$Vi,87:$Vj,88:$Vk,89:$Vl,90:$Vm,91:$Vn,92:$Vo,105:$Vp,108:$Vq,109:$Vr,112:$Vs,114:$Vt,116:47,117:$Vu,118:$Vv,119:$Vw,124:$Vx,125:$Vy,126:$Vz,127:$VA,128:$VB},{8:$VE,9:$VF,10:$VG,12:$VH,22:304,34:305,43:$VJ},o($VV,[2,65]),{11:$VH1,63:$VI1,87:$VJ1,108:$VK1,110:306,111:264,112:$VL1,113:$VM1,114:$VN1,115:$VO1},o($VR1,[2,148]),{15:$VK,47:$VL,63:$VM,92:$VN,104:307,108:$VO,109:$VP,112:$VQ,114:$VR,117:$VS,118:$VT,119:$VU,123:97},{15:$VK,47:$VL,63:$VM,92:$VN,104:308,108:$VO,109:$VP,112:$VQ,114:$VR,117:$VS,118:$VT,119:$VU,123:97},{101:[1,309]},o($Vv1,[2,135]),o($VW,[2,71]),{31:310,70:$Vx1,83:$Vy1,84:$Vz1,85:185,119:$VA1,120:$VB1,121:$VC1},o($VW,[2,79]),o($Vs1,$V5,{5:311}),{8:$VE,9:$VF,10:$VG,12:$VH,22:312,43:$Vu1},o($VD,[2,41]),o($VD,[2,44]),{8:$VE,9:$VF,10:$VG,12:$VH,22:313,43:$Vu1},o($VQ1,[2,146],{111:293,11:$VH1,63:$VI1,87:$VJ1,108:$VK1,112:$VL1,113:$VM1,114:$VN1,115:$VO1}),o($Vv1,[2,141],{123:181,11:[1,314],15:$VK,47:$VL,63:$VM,92:$VN,108:$VO,109:$VP,112:$VQ,114:$VR,117:$VS,118:$VT,119:$VU}),o($Vv1,[2,142],{123:181,11:[1,315],15:$VK,47:$VL,63:$VM,92:$VN,108:$VO,109:$VP,112:$VQ,114:$VR,117:$VS,118:$VT,119:$VU}),o($Vv1,[2,129]),{32:[1,316],70:$Vx1,85:237,119:$VA1,120:$VB1,121:$VC1},{6:13,7:14,8:$V6,9:$V7,10:$V8,11:$V9,12:$Va,21:20,23:21,24:22,25:23,26:24,27:25,28:$Vb,33:[1,317],35:$Vc,36:$Vd,37:29,38:$Ve,40:$Vf,42:$Vg,45:33,46:44,47:$Vh,48:45,50:46,63:$Vi,87:$Vj,88:$Vk,89:$Vl,90:$Vm,91:$Vn,92:$Vo,105:$Vp,108:$Vq,109:$Vr,112:$Vs,114:$Vt,116:47,117:$Vu,118:$Vv,119:$Vw,124:$Vx,125:$Vy,126:$Vz,127:$VA,128:$VB},o($Vs1,$V5,{5:318}),o($VD,[2,45]),{11:$VH1,63:$VI1,87:$VJ1,95:319,108:$VK1,110:263,111:264,112:$VL1,113:$VM1,114:$VN1,115:$VO1},{11:$VH1,63:$VI1,87:$VJ1,95:320,108:$VK1,110:263,111:264,112:$VL1,113:$VM1,114:$VN1,115:$VO1},o($VW,[2,75]),o($VD,[2,38]),{6:13,7:14,8:$V6,9:$V7,10:$V8,11:$V9,12:$Va,21:20,23:21,24:22,25:23,26:24,27:25,28:$Vb,33:[1,321],35:$Vc,36:$Vd,37:29,38:$Ve,40:$Vf,42:$Vg,45:33,46:44,47:$Vh,48:45,50:46,63:$Vi,87:$Vj,88:$Vk,89:$Vl,90:$Vm,91:$Vn,92:$Vo,105:$Vp,108:$Vq,109:$Vr,112:$Vs,114:$Vt,116:47,117:$Vu,118:$Vv,119:$Vw,124:$Vx,125:$Vy,126:$Vz,127:$VA,128:$VB},o($Vv1,[2,139],{109:$VP1}),o($Vv1,[2,140],{109:$VP1}),o($VD,[2,39])],
defaultActions: {},
parseError: function parseError (str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
    }
},
parse: function parse(input) {
    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
            sharedState.yy[k] = this.yy[k];
        }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
            function lex() {
            var token;
            token = tstack.pop() || lexer.lex() || EOF;
            if (typeof token !== 'number') {
                if (token instanceof Array) {
                    tstack = token;
                    token = tstack.pop();
                }
                token = self.symbols_[token] || token;
            }
            return token;
        }
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
        if (typeof action === 'undefined' || !action.length || !action[0]) {
            var errStr = '';
            expected = [];
            for (p in table[state]) {
                if (this.terminals_[p] && p > TERROR) {
                    expected.push('\'' + this.terminals_[p] + '\'');
                }
            }
            if (lexer.showPosition) {
                errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
            } else {
                errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
            }
            this.parseError(errStr, {
                text: lexer.match,
                token: this.terminals_[symbol] || symbol,
                line: lexer.yylineno,
                loc: yyloc,
                expected: expected
            });
        }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};

/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function(match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex () {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin (condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState () {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules () {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState (n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState (condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0: this.begin("acc_title");return 38; 
break;
case 1: this.popState(); return "acc_title_value"; 
break;
case 2: this.begin("acc_descr");return 40; 
break;
case 3: this.popState(); return "acc_descr_value"; 
break;
case 4: this.begin("acc_descr_multiline");
break;
case 5: this.popState(); 
break;
case 6:return "acc_descr_multiline_value";
break;
case 7:
                                                    // console.log('=> shapeData', yy_.yytext);
                                                    this.pushState("shapeData"); yy_.yytext=""; return 43 
break;
case 8:
                                                    // console.log('=> shapeDataStr', yy_.yytext);
                                                    this.pushState("shapeDataStr");
                                                    return 43;
                                                
break;
case 9:
                                                    // console.log('shapeData <==', yy_.yytext);
                                                    this.popState(); return 43
break;
case 10:
                                                    // console.log('shapeData', yy_.yytext);
                                                    const re = /\n\s*/g;
                                                    yy_.yytext = yy_.yytext.replace(re,"<br/>");
                                                    return 43
break;
case 11:
                                                    // console.log('shapeData', yy_.yytext);
                                                    return 43;
                                                
break;
case 12:
                                                    // console.log('<== root', yy_.yytext)
                                                    this.popState();
                                                
break;
case 13:this.begin("callbackname");
break;
case 14:this.popState();
break;
case 15:this.popState(); this.begin("callbackargs");
break;
case 16:return 98;
break;
case 17:this.popState();
break;
case 18:return 99;
break;
case 19: return "MD_STR";
break;
case 20: this.popState();
break;
case 21: this.begin("md_string");
break;
case 22: return "STR"; 
break;
case 23:this.popState();
break;
case 24:this.pushState("string");
break;
case 25:return 87;
break;
case 26:return 105;
break;
case 27:return 88;
break;
case 28:return 107;
break;
case 29:return 89;
break;
case 30:return 90;
break;
case 31:return 100;
break;
case 32:this.begin("click");
break;
case 33:this.popState();
break;
case 34:return 91;
break;
case 35:if(yy.lex.firstGraph()){this.begin("dir");}  return 13;
break;
case 36:return 28;
break;
case 37:return 36;
break;
case 38:return 35;
break;
case 39:return 33;
break;
case 40:return 101;
break;
case 41:return 101;
break;
case 42:return 101;
break;
case 43:return 101;
break;
case 44: this.popState();  return 14; 
break;
case 45: this.popState();  return 15; 
break;
case 46: this.popState();  return 15; 
break;
case 47: this.popState();  return 15; 
break;
case 48: this.popState();  return 15; 
break;
case 49: this.popState();  return 15; 
break;
case 50: this.popState();  return 15; 
break;
case 51: this.popState();  return 15; 
break;
case 52: this.popState();  return 15; 
break;
case 53: this.popState();  return 15; 
break;
case 54: this.popState();  return 15; 
break;
case 55:return 124;
break;
case 56:return 125;
break;
case 57:return 126;
break;
case 58:return 127;
break;
case 59:return 128;
break;
case 60: return 81; 
break;
case 61:return 108;
break;
case 62:return 114;
break;
case 63:return 49;
break;
case 64:return 63;
break;
case 65:return 47;
break;
case 66:return 9;
break;
case 67:return 109;
break;
case 68:return 118;
break;
case 69: this.popState(); return 80; 
break;
case 70: this.pushState("edgeText"); return 78; 
break;
case 71:return 122;
break;
case 72: return 80; 
break;
case 73: /* inline comment - skip */ 
break;
case 74: this.popState(); return 56; 
break;
case 75:return "TEXT"
break;
case 76: this.pushState("ellipseText"); return 55; 
break;
case 77: this.popState(); return 58; 
break;
case 78: this.pushState("text"); return 57; 
break;
case 79: this.popState(); return 60; 
break;
case 80: this.pushState("text"); return 59; 
break;
case 81: return 61; 
break;
case 82: this.pushState("text"); return 70; 
break;
case 83: this.popState(); return 67; 
break;
case 84: this.pushState("text") ;return 66; 
break;
case 85: this.popState(); return 52; 
break;
case 86: this.pushState("text"); return 51; 
break;
case 87: /* inline comment - skip */ 
break;
case 88: this.popState(); return 72; 
break;
case 89: this.popState(); return 74; 
break;
case 90:return 120;
break;
case 91: this.pushState("trapText"); return 71; 
break;
case 92: this.pushState("trapText"); return 73; 
break;
case 93:return 121;
break;
case 94:return 70;
break;
case 95:return 93;
break;
case 96:return 'SEP';
break;
case 97:return 92;
break;
case 98:return 118;
break;
case 99:return 114;
break;
case 100:return 47;
break;
case 101:return 8;
break;
case 102:
    return 112;

break;
case 103:return 117
break;
case 104:return 119;
break;
case 105: this.popState(); return 65; 
break;
case 106: this.pushState("text"); return 65; 
break;
case 107: this.popState(); return 54; 
break;
case 108: this.pushState("text"); return 53; 
break;
case 109: this.popState(); return 32; 
break;
case 110: this.pushState("text"); return 30; 
break;
case 111: this.popState(); return 69 
break;
case 112: this.pushState("text"); return 68 
break;
case 113: /* inline comment - skip */ 
break;
case 114:return "TEXT";
break;
case 115:return 'QUOTE';
break;
case 116:return 10;
break;
case 117:return 11;
break;
case 118:return 12;
break;
}
},
rules: [/^(?:accTitle\s*:\s*)/,/^(?:(?!\n||)*[^\n]*)/,/^(?:accDescr\s*:\s*)/,/^(?:(?!\n||)*[^\n]*)/,/^(?:accDescr\s*\{\s*)/,/^(?:[\}])/,/^(?:[^\}]*)/,/^(?:@\{)/,/^(?:["])/,/^(?:["])/,/^(?:[^\"]+)/,/^(?:[^}^"]+)/,/^(?:\})/,/^(?:call[\s]+)/,/^(?:\([\s]*\))/,/^(?:\()/,/^(?:[^(]*)/,/^(?:\))/,/^(?:[^)]*)/,/^(?:[^`"]+)/,/^(?:[`]["])/,/^(?:["][`])/,/^(?:[^"]+)/,/^(?:["])/,/^(?:["])/,/^(?:style\b)/,/^(?:default\b)/,/^(?:linkStyle\b)/,/^(?:interpolate\b)/,/^(?:classDef\b)/,/^(?:class\b)/,/^(?:href[\s])/,/^(?:click[\s]+)/,/^(?:[\s\n])/,/^(?:[^\s\n]*)/,/^(?:agentflow-beta\b)/,/^(?:flow\b)/,/^(?:connector\b)/,/^(?:global\b[ \t]*)/,/^(?:end\b[ \t]*)/,/^(?:_self\b)/,/^(?:_blank\b)/,/^(?:_parent\b)/,/^(?:_top\b)/,/^(?:(\r?\n)*\s*\n)/,/^(?:\s*LR\b)/,/^(?:\s*RL\b)/,/^(?:\s*TB\b)/,/^(?:\s*BT\b)/,/^(?:\s*TD\b)/,/^(?:\s*BR\b)/,/^(?:\s*<)/,/^(?:\s*>)/,/^(?:\s*\^)/,/^(?:\s*v\b)/,/^(?:.*direction\s+TB[^\n]*)/,/^(?:.*direction\s+BT[^\n]*)/,/^(?:.*direction\s+RL[^\n]*)/,/^(?:.*direction\s+LR[^\n]*)/,/^(?:.*direction\s+TD[^\n]*)/,/^(?:[^\s\"]+@(?=[^\{\"]))/,/^(?:[0-9]+)/,/^(?:#)/,/^(?::::)/,/^(?::)/,/^(?:&)/,/^(?:;)/,/^(?:,)/,/^(?:\*)/,/^(?:\s*--+[x>]\s*)/,/^(?:\s*--\s*)/,/^(?:[^-]|-(?!-)+)/,/^(?:\s*-\.+-\s*)/,/^(?:%%(?!\{)[^\n]*)/,/^(?:[-/\)][\)])/,/^(?:[^\(\)\[\]\{\}]|!\)+)/,/^(?:\(-)/,/^(?:\]\))/,/^(?:\(\[)/,/^(?:\]\])/,/^(?:\[\[)/,/^(?:\[\|)/,/^(?:>)/,/^(?:\)\])/,/^(?:\[\()/,/^(?:\)\)\))/,/^(?:\(\(\()/,/^(?:%%(?!\{)[^\n]*)/,/^(?:[\\(?=\])][\]])/,/^(?:\/(?=\])\])/,/^(?:\/(?!\])|\\(?!\])|(?:[^\\\[\]\(\)\{\}\/%]+|(?!))+)/,/^(?:\[\/)/,/^(?:\[\\)/,/^(?:<)/,/^(?:>)/,/^(?:\^)/,/^(?:\\\|)/,/^(?:v\b)/,/^(?:\*)/,/^(?:#)/,/^(?:&)/,/^(?:[ \t]*%%(?!\{)[^\n]*)/,/^(?:([A-Za-z0-9!"\#$%&'*+\.`?\\_\/]|-(?=[^\>\-\.])|(?!))+)/,/^(?:-)/,/^(?:[\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6]|[\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377]|[\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5]|[\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA]|[\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE]|[\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA]|[\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0]|[\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977]|[\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2]|[\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A]|[\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39]|[\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8]|[\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C]|[\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C]|[\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99]|[\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0]|[\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D]|[\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3]|[\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10]|[\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1]|[\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81]|[\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3]|[\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6]|[\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A]|[\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081]|[\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D]|[\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0]|[\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310]|[\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C]|[\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711]|[\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7]|[\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C]|[\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16]|[\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF]|[\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC]|[\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D]|[\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D]|[\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3]|[\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F]|[\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128]|[\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184]|[\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3]|[\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6]|[\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE]|[\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C]|[\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D]|[\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC]|[\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B]|[\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788]|[\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805]|[\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB]|[\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28]|[\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5]|[\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4]|[\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E]|[\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D]|[\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36]|[\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D]|[\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC]|[\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF]|[\uFFD2-\uFFD7\uFFDA-\uFFDC])/,/^(?:\|)/,/^(?:\|)/,/^(?:\))/,/^(?:\()/,/^(?:\])/,/^(?:\[)/,/^(?:(\}))/,/^(?:\{)/,/^(?:%%(?!\{)[^\n]*)/,/^(?:(?:[^\[\]\(\)\{\}\|\"%]+|(?!))+)/,/^(?:")/,/^(?:(\r?\n)+)/,/^(?:\s)/,/^(?:$)/],
conditions: {"shapeDataEndBracket":{"rules":[21,24,76,78,80,84,86,91,92,106,108,110,112],"inclusive":false},"shapeDataStr":{"rules":[9,10,21,24,76,78,80,84,86,91,92,106,108,110,112],"inclusive":false},"shapeData":{"rules":[8,11,12,21,24,76,78,80,84,86,91,92,106,108,110,112],"inclusive":false},"callbackargs":{"rules":[17,18,21,24,76,78,80,84,86,91,92,106,108,110,112],"inclusive":false},"callbackname":{"rules":[14,15,16,21,24,76,78,80,84,86,91,92,106,108,110,112],"inclusive":false},"href":{"rules":[21,24,76,78,80,84,86,91,92,106,108,110,112],"inclusive":false},"click":{"rules":[21,24,33,34,76,78,80,84,86,91,92,106,108,110,112],"inclusive":false},"edgeText":{"rules":[21,24,69,71,76,78,80,84,86,91,92,106,108,110,112],"inclusive":false},"trapText":{"rules":[21,24,76,78,80,84,86,87,88,89,90,91,92,106,108,110,112],"inclusive":false},"ellipseText":{"rules":[21,24,73,74,75,76,78,80,84,86,91,92,106,108,110,112],"inclusive":false},"text":{"rules":[21,24,76,77,78,79,80,83,84,85,86,91,92,105,106,107,108,109,110,111,112,113,114],"inclusive":false},"vertex":{"rules":[21,24,76,78,80,84,86,91,92,106,108,110,112],"inclusive":false},"dir":{"rules":[21,24,44,45,46,47,48,49,50,51,52,53,54,76,78,80,84,86,91,92,106,108,110,112],"inclusive":false},"acc_descr_multiline":{"rules":[5,6,21,24,76,78,80,84,86,91,92,106,108,110,112],"inclusive":false},"acc_descr":{"rules":[3,21,24,76,78,80,84,86,91,92,106,108,110,112],"inclusive":false},"acc_title":{"rules":[1,21,24,76,78,80,84,86,91,92,106,108,110,112],"inclusive":false},"md_string":{"rules":[19,20,21,24,76,78,80,84,86,91,92,106,108,110,112],"inclusive":false},"string":{"rules":[21,22,23,24,76,78,80,84,86,91,92,106,108,110,112],"inclusive":false},"INITIAL":{"rules":[0,2,4,7,13,21,24,25,26,27,28,29,30,31,32,35,36,37,38,39,40,41,42,43,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,72,76,78,80,81,82,84,86,91,92,93,94,95,96,97,98,99,100,101,102,103,104,106,108,110,112,115,116,117,118],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})(); 
	parser.parser = parser;
	export { parser };
	export default parser;
	